import React, { useEffect, useState } from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

export default function PayPalCheckout({ createOrder, captureOrder, onSuccess, onError }) {
  const [clientId, setClientId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    fetch(`${API_URL}/payments/paypal/config`)
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok || !data.clientId) throw new Error(data.error || 'PayPal indisponible');
        if (active) setClientId(data.clientId);
      })
      .catch((err) => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);

  if (error) return <div className="error-message" role="alert">{error}</div>;
  if (!clientId) return <p>Chargement de PayPal...</p>;

  return (
    <PayPalScriptProvider options={{ clientId, currency: 'USD', intent: 'capture', components: 'buttons' }}>
      <PayPalButtons
        style={{ layout: 'vertical', shape: 'rect', label: 'paypal' }}
        createOrder={async () => {
          try {
            const orderId = await createOrder();
            if (!orderId) throw new Error('Commande PayPal absente');
            return orderId;
          } catch (err) {
            onError?.(err);
            throw err;
          }
        }}
        onApprove={async (data) => {
          try {
            const result = await captureOrder(data.orderID);
            onSuccess?.(result);
          } catch (err) {
            onError?.(err);
          }
        }}
        onError={(err) => onError?.(err)}
      />
    </PayPalScriptProvider>
  );
}
